import { useEffect, useState } from 'react'

/** Open state for the admin dev rail, plus its Escape-to-close key handler. Lives on the
 *  grid rather than inside `GameweekDevTools` because the rail renders at a different
 *  child index in the no-fixtures branch, so component-local state would be dropped when
 *  fixtures arrive. */
export function useDevToolsRail() {
  const [devToolsOpen, setDevToolsOpen] = useState(false)

  useEffect(() => {
    if (!devToolsOpen) return
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setDevToolsOpen(false)
    }
    document.addEventListener('keydown', handleKeyDown)
    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [devToolsOpen])

  return { devToolsOpen, setDevToolsOpen }
}
